import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OverlayLoader from "../../../../../components/loader/OverlayLoader/OverlayLoader";
import {
  StyledCard,
  StyledCardBody,
  StyledCardHeader,
} from "../../../../../styles/CardStyles";
import {
  StyledFlexColumn,
  StyledFlexRow,
} from "../../../../../styles/LayoutStyles";
import { StyledAltIconButton } from "../../../../../styles/ButtonStyles";
import { faCopy, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useLanguageContext } from "../../../../../context/LanguageContext";
import { useTheme } from "styled-components";
import LabelForm from "./label/LabelForm";
import { getLabelItemForm } from "../../label_items/LabelItems";

function SelectedFormView({
  printerData,
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
  fields,
  images,
  onDelete,
  onDuplicate,
  onClose,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();
  const Form = printerData.label_selected
    ? LabelForm
    : getLabelItemForm(selectedLabelItem?.type);

  return (
    (selectedLabelItem || printerData.label_selected) && (
      <OverlayLoader
        groups={"printer_page_fetch"}
        containerStyle={{ flex: 1, overflow: "hidden" }}
      >
        <StyledCard style={{ height: "100%" }}>
          <StyledFlexColumn style={{ gap: 0, height: "100%" }}>
            <StyledCardHeader>
              <StyledFlexRow
                style={{ justifyContent: "space-between", flexWrap: "nowrap" }}
              >
                <h2>
                  {selectedLabelItem &&
                    translate(
                      `eva.main.printers.label.item.types.${selectedLabelItem.type}`
                    )}
                  {printerData.label_selected &&
                    translate("eva.main.validation.attributes.label")}
                </h2>

                <StyledFlexRow
                  style={{ flexWrap: "nowrap", gap: theme.spacing.small }}
                >
                  {selectedLabelItem && (
                    <StyledAltIconButton
                      onClick={onDelete}
                      title={translate("eva.main.entities.states.delete", [
                        { key: "entities", value: "" },
                      ])}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </StyledAltIconButton>
                  )}

                  {selectedLabelItem && (
                    <StyledAltIconButton
                      onClick={onDuplicate}
                      title={translate("eva.main.entities.states.duplicate", [
                        { key: "entities", value: "" },
                      ])}
                    >
                      <FontAwesomeIcon icon={faCopy} />
                    </StyledAltIconButton>
                  )}

                  <StyledAltIconButton
                    onClick={onClose}
                    title={translate("eva.main.general.close")}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </StyledAltIconButton>
                </StyledFlexRow>
              </StyledFlexRow>
            </StyledCardHeader>

            <StyledCardBody style={{ overflowY: "auto", flex: 1 }}>
              {Form && (
                <Form
                  printerData={printerData}
                  setPrinterData={setPrinterData}
                  selectedLabelItemIndex={selectedLabelItemIndex}
                  selectedLabelItem={selectedLabelItem}
                  submitError={submitError}
                  fields={fields}
                  images={images}
                />
              )}
            </StyledCardBody>
          </StyledFlexColumn>
        </StyledCard>
      </OverlayLoader>
    )
  );
}

export default SelectedFormView;
